import { useMemo } from 'react'
import { displayDateWithFormattedHours } from '../../utils/globals/date'
import TwinIcon, { TwinIconProp } from '../TwinIcon'
import TwinToolTip from '../TwinToolTip'
import './activityDisplay.sass'

interface ActivityDisplayProps {
    renderThis: JSX.Element[]
    className?: string
}

const ActivityDisplay: React.FC<ActivityDisplayProps> = ({ renderThis, className }) => {
    return (
        <div className={'flex-auto overflow-y-auto overflow-x-hidden activity_display_parent ' + (className || '')} >
            <div className={'flex flex-auto relative activity_display pt-25'}>
                <div className='activity_display_line'></div>
                <div className='flex flex-col flex-auto gap-20 activity_display_inner'>
                    {renderThis}
                </div>
            </div>
        </div>
    )
}

interface CustomerProjectActivityComponentProps extends ActivityDisplayHeaderProps {
    icon: TwinIconProp
    mainColor?: string
    children?: React.ReactNode
    id?: number
    nameTrigger: string
    tooltipName: string
}


export const ActivityDisplayComponent: React.FC<CustomerProjectActivityComponentProps> = ({ mainColor, icon, children, ...header }) => {
    return (
        <div className='flex flex-col flex-auto gap-10 relative activity_display_component'>
            <div className='flex'>
                <div className=' flex rounded-full p-8 border bg-white mr-14 activity_display_component_inner h-34 w-34' style={{ borderColor: mainColor || '#D6D6D6' }}>
                    <TwinIcon icon={icon} className='w-16 h-16 ' style={{ color: mainColor || '#43BAA5' }}></TwinIcon>
                </div>
                <ActivityDisplayHeader {...header} />
            </div>
            {
                children ?
                    <div className='flex flex-col flex-auto ml-48 bg-white rounded-xl activity_display_body'>
                        {children}
                    </div>
                    : null
            }
        </div>
    )
}

export interface ActivityDisplayHeaderProps {
    image?: string
    secondText?: string
    headerText?: string
    date: string
    showImage?: boolean
    id?: number
    nameTrigger?: string
    tooltipName: string
}

export const ActivityDisplayHeader: React.FC<ActivityDisplayHeaderProps> = ({ date, headerText, secondText, image, showImage = true, id, nameTrigger, tooltipName }) => {
    return (
        <div className='flex gap-12'>
            {showImage ? <ActivityDisplayImage id={id || 0} img={image ?? '/user-png.png'} name={nameTrigger} tooltipName={tooltipName} className='activity_display_header_image mt-3'/> : null}
            <div className='items-center flex activity_display_header'>
                <div className='font-medium'>
                    <span className='mr-3 '>{headerText}</span>
                    {secondText ? <span className='italic' >{secondText}</span> : null}
                </div>
                <span className='activity_display_header_date text-gray-9D ml-12'>{displayDateWithFormattedHours(new Date(date))}</span>
            </div>
        </div>
    )
}


interface ActivityDisplayImageProps {
    id: number
    name?: string
    img: string
    tooltipName?: string
    className?: string
}

export const ActivityDisplayImage: React.FC<ActivityDisplayImageProps> = ({ id, name, img, tooltipName, className }) => {
    const myName = name
    const idTooltip = useMemo(() => 'Tooltip_CustomRenderImage' + tooltipName + '' + String(id), [id, tooltipName])
    return (
        <div className={'twin_elipsis ' + (className || '')}>
            {myName ?
                <TwinToolTip id={idTooltip} place='top' className='max-w-600'>
                    <p className='text-wrap-initial'>{myName}</p>
                </TwinToolTip>
                : null}
            <img data-tooltip-id={idTooltip} src={img} alt={name} className='w-27 object-cover min-w-27 h-27 rounded-full' />
        </div>
    )
}


export default ActivityDisplay